import { Pipe } from "@angular/core";
import { SettingSection } from "../enums/setting-section.enum";
import { SettingsGroupName } from "../enums/settings-group-name.enum";
import { SettingTemplateGrouping } from "../interfaces/link-setting-template-grouping.interface";
import { LinkSettingView } from "../interfaces/link-setting-view.interface";
import { SectionGroup, SectionSetting } from "../link/link-edit-setup/link-edit-setup.component";
import { SettingTemplateGroupingService } from "../services/setting-template-grouping.service";


@Pipe({
    name: "settingSectionSortPipe",
    pure: true,
    standalone: true
})
export class SettingSectionSortPipe {
    transform(array: Array<SectionSetting>): Array<SectionSetting> {
        array.sort((a: SectionSetting, b: SectionSetting) => {
            const indexOfA = Object.keys(SettingSection).indexOf(a.section);
            const indexOfB = Object.keys(SettingSection).indexOf(b.section);
            if (indexOfA < indexOfB) {
                return -1;
            } else if (indexOfA > indexOfB) {
                return 1;
            } else {
                return 0;
            }
        });
        return array;
    }
}

@Pipe({
    name: "settingGroupNameSortPipe",
    pure: true,
    standalone: true
})
export class SettingGroupNameSortPipe {
    transform(array: Array<SectionGroup>, groupings: SettingTemplateGrouping[] ): Array<SectionGroup> {
        array.sort((a: SectionGroup, b: SectionGroup) => {

            const grouping1 = groupings.find(item => item.name.toLowerCase() == a.name.toLowerCase())
            const grouping2 = groupings.find(item => item.name.toLowerCase() == b.name.toLowerCase())

            // console.log('group 1:' + grouping1.index)
            // console.log('group 2:' + grouping2.index)

            if(!grouping1 && !grouping2)
            {
                return 1;
            }
            else if(!grouping1)
            {
                return 1;
            }
            else if(!grouping2)
            {
                return -1;
            }

            const indexOfA = Object.keys(SettingsGroupName).indexOf(a.name.toLowerCase());
            const indexOfB = Object.keys(SettingsGroupName).indexOf(b.name.toLowerCase());
            if (grouping1.index < grouping2.index) {
                return -1;
            } else if (grouping1.index > grouping2.index) {
                return 1;
            } else {
                return 0;
            }
        });
        return array;
    }
}

@Pipe({
    name: "settingSortPipe",
    pure: true,
    standalone: true
})
export class SettingSortPipe {

    transform(array: Array<LinkSettingView>): Array<LinkSettingView> {
        
        array.sort((n1, n2) => {
            
            if (n1.sortingIndex > n2.sortingIndex) {
                return 1;
            }

            if (n1.sortingIndex < n2.sortingIndex) {
                return -1;
            }

            return 0;
        });

        return array;
    }
}